import { createGlobalStyle } from "styled-components";

export const GlobalStyles = createGlobalStyle`
  body {
    margin: 0;
    min-height: 100vh;
    min-height: -webkit-fill-available;
    display: ${(props) => (props.$overflow ? "inherit" : "flex")};
    justify-content: center;
    background-color: #F2F2F2;
    height: ${(props) => (props.$overflow ? "100%" : "auto")};
    overflow: ${(props) => (props.$overflow ? "hidden" : "auto")};
  }

  html {
    font-family: 'Oswald';
    height: -webkit-fill-available;
  }

  a {
    text-decoration: none;
  }

  #___gatsby {
    height: 100%;
    width: 100%;
    max-width: 1600px;
  }

  #gatsby-focus-wrapper {
    height: 100%;
  }
`;
